<template>
  <div class="recient-news">
    <div class="new-cell" @click="goToLink(noticia.id)">
      <v-img
        :src="validateImage(newsPath + noticia.image, failed_image)"
        v-on:error="onImgError"
        max-width="80px"
        width="80px"
        height="80px"
        class="noticia-image"
        :aspect-ratio="1"
      />
      <div class="new-content">
        <div class="new-title">{{ noticia.title }}</div>
        <span class="cta grey-2">
          {{ new Date(noticia.date).toLocaleDateString() }}
        </span>
        <!-- <p class="cta grey-2">{{ noticia.tag }}</p> -->
      </div>
      <v-icon style="width: 40px !important; flex:0">mdi-chevron-right</v-icon>
    </div>
  </div>
</template>
<script>
import $ from "jquery";

export default {
  name: "Recent_news",
  data: () => ({
    failed_image: false
  }),
  props: {
    noticia: {
      type: Object,
      required: true
    }
  },
  computed: {
    newsPath: () => $(location).attr("origin") + "/archivos/noticias/"
  },
  methods: {
    goToLink(id) {
      this.$router.push({ name: "Noticia", params: { id: id } });
      
    },
    validateImage(image, failed_image) {
      return !failed_image ? image : "https://www.uabc.mx/wp-content/uploads/2022/01/RFoto01.jpg";
    },
    onImgError() {
      this.failed_image = true;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/global";
.recient-news {
  flex: 1;
  padding: 0 2%;
  margin-top: 15px;
  margin-bottom: 15px;
}
.new-title {
  // Addition lines for 2 line or multiline ellipsis
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.new-cell {
  display: flex;
  height: 100px;
  border: solid 1px #e0e0e0;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  .noticia-image {
    width: 120px;
    height: 120px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 5px;
    margin-right: 10px;
  }
  .new-content {
    flex: 1 !important;
  }
}

@media (max-width: $screen-lg-min) and (min-width: 500px) {
  .new-title {
    // color: red;
  }
}

@media only screen and (max-width: $screen-lg-min) {
    .recient-news {
      padding: 0 0;
      margin-top: 2px;
        margin-bottom: 2px;
    }
  .new-title {
    // color: blue;
  }
}

@media (max-width: 500px) {
  .new-title {
    // color: green;
  }
}
</style>
